angular.module('TetherApp').controller('SubscriptionController', [
    '$window',
    'subscriptionService',
    function (
        $window,
        subscriptionService
    ) {
        let self = this;

        self.delete = function(subscriptionId) {
            if($window.confirm(self.deleteConfirmationText)) {
                subscriptionService.deleteSubscription(subscriptionId)
                    .then(onSubscriptionDelete, onError);
            }
        };

        let onSubscriptionDelete = function (data) {
            $window.location.reload();
        };

        let onError = function(reason) {
            // console.log('Error occurred while deleting keyword');
        };
    }
]);
